<template>
	<div class="zzgk_dialog" style="max-height: 500px;overflow-y: scroll;">
		<el-dialog 
			:modal-append-to-body='true'
			width="500px"
			center
			:append-to-body='true'
			@close="closeWin"
			:visible.sync="addDwdf">
			<div slot="title" class="addtitle">
				<div>
					<i class="icon adddzz"></i>
					{{title}}
					<div class="addline"></div>
				</div>
			</div>
			<div class="formData2">
				<el-form ref="form" :model="formData" class="formWrap" >
					<el-form-item
					:key="index"
					 :label="item.class_name" 
					v-for="(item,index) in tableHeader"
					class="form_item" prop="allocate_class">
						<el-input-number v-model="formData.score[index]" :min="1" :max="parseInt(item.score)"></el-input-number>
					</el-form-item>
					<div class="form_item">
						总分：<input disabled style="border: none;background: none;" type="" name="" id="" :value="total" />
					</div>
					<div class="form_item">
						星级：{{changeStar(total)}}
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submit()">保 存</el-button>
				<el-button @click="closeWin">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { Message } from 'element-ui'
	import { dwgl } from '@/axios'
	let that;
	export default{
		data(){
			return{
				title:"党委打分",
				addDwdf:false,
				formData:{
					dwid:this.$store.state.user.userinfo.id,
					uid:"",//被打分支部id
					flag:"",//被打分支部flag
					score:[],
					class_id:"",
					total:"",
					star:"",
					star_num:"",
					rescore:"",//2:打分  1:重新打分
					year:""
				},
				id:""
			}
		},
		props:{
			tableHeader:{
				type:Array,
				default:[]
			},
			year:{
				type:Number,
				default:new Date().getFullYear()
			}
		},
		computed:{
			total(){
				let totals=0;
				if(typeof(this.formData.score) == "string"){
					this.formData.score = this.formData.score.split(",")
				}
				for(let i=0;i<this.formData.score.length;i++){
					totals += this.formData.score[i];
				}
				return totals
			},
		},
		created(){that = this;},
		methods:{
			// 星级转换
			changeStar(total){
				if(that.total>=90){
					that.formData.star = "五星级"
					that.formData.star_num = 5;
					return total = "五星级"
				}else if(that.total>79&&that.total<90){
					that.formData.star = "四星级"
					that.formData.star_num = 4
					return total = "四星级"
				}else if(that.total>69&&that.total<80){
					that.formData.star = "三星级"
					that.formData.star_num = 3
					return total = "三星级"
				}else if(that.total>59&&that.total<70){
					that.formData.star = "二星级"
					that.formData.star_num = 2
					return total = "二星级"
				}else{
					that.formData.star = "一星级"
					that.formData.star_num = 1
					return total = "一星级"
				}
			},
			// 打开打分弹窗
			openWin(data){
				that.addDwdf = true;
				that.id = data.id;
				that.bindData(data)
			},
			// 关闭弹窗
			closeWin(){
				that.addDwdf = false;
				that.id = "";
				that.formData.score = [];
			},
			// 打分
			submit(){
				that.formData.total = that.total;
				that.formData.score = that.formData.score.toString();
				dwgl.starDoApproval(that.formData).then(res => {
					if(res.code == 200){
						that.closeWin();
						that.$emit("dataList")
					}
				})
			},
			// 编辑绑定数据
			bindData(data){
				that.formData.score = [];
				that.formData.uid = data.id;
				that.formData.flag = data.flag;
				that.formData.star = that.star;
				that.formData.star_num = that.star_num;
				that.formData.year = that.year;
				that.tableHeader.forEach((item,index) => {
					if(index==that.tableHeader.length-1){
						that.formData.class_id += item.id
					}else{
						that.formData.class_id += item.id+','
					}
				});
				if(data.complete == 2){
					// 打分
					that.formData.rescore = 2;
					that.formData.total = that.total;
					for(let i=0;i<that.tableHeader.length;i++){
						that.formData.score.push(that.tableHeader[i].score)
					}
				}else{
					// 重新打分
					that.formData.rescore = 1;
					that.formData.total = data.total;
					if(data.score.length == that.tableHeader.length){
						for(let i=0;i<data.score.length;i++){
							that.formData.score.push(data.score[i])
						}
					}else{
						for(let i=0;i<data.score.length;i++){
							that.formData.score.push(data.score[i])
						}
						for(let i=0;i<(that.tableHeader.length-data.score.length);i++){
							that.formData.score.push(0)
						}
					}
				}
			},
		}
	}
</script>

<style lang="scss">
	.zzgk_dialog{
		.el-dialog{
			z-index: 1000;
			width: 500px;
		}
	}
	.formData2{
		display: flex;
		justify-content: center;
		width: 100%;
		max-height: 400px;
		overflow-y: scroll;
		.el-form-item{
			display: flex;
			align-items: center;
		}
	}
</style>
